import React, { useState, useEffect } from "react";
import { API, graphqlOperation } from "aws-amplify";
import { getComment } from "../../../../graphql/queries";
import { updateComment } from "../../../../graphql/mutations";
import { toast } from "react-toastify";
import PagePreLoad from "../../../../components/Common/PagePreLoad";
import { Form, Alert } from "react-bootstrap";
import CardContainer from "../../../../components/Common/CardContainer";
import ButtonInput from "../../../../components/Common/ButtonInput";
import * as BootstrapVariants from "../../../../constants/Bootstrap/Variants";
import * as GlobalSubmitUIDelay from "../../../../constants/AppBehaviour/globalSubmitUIDelay";
import PostGeneralInfo from "../GeneralInfo";
import getCurrentUserStarPoints from "../../../Common/PointSystem/handlers/getCurrentUserStarPoints";
import getPointSystemByTypeAsync from "../../../Common/PointSystem/handlers/getPointSystemByTypeAsync";
import updateUserStarPointsByUserId from "../../../Common/PointSystem/handlers/updateUserStarPointsByUserId";

const CommentProfane = (props) => {
  const [commentId, setCommentId] = useState(null);
  const [commentData, setCommentData] = useState(null);
  const [userId, setUserId] = useState(null);
  const [commentCurrentProfaneState, setCommentCurrentProfaneState] = useState(
    null
  );
  const [isLoading, setIsLoading] = useState(true);
  const [generalError, setGeneralError] = useState("");
  const [formSubmitInProgress, setFormSubmitInProgress] = useState(false);
  const [
    formSubmitDemeritInProgress,
    setFormSubmitDemeritInProgress,
  ] = useState(false);
  const [demeritPoint, setDemeritPoint] = useState(null);

  useEffect(() => {
    getPointSystemForFlagesContent();
    getCommentData();
  }, []);

  const getCommentData = async () => {
    try {
      const result = await API.graphql(
        graphqlOperation(getComment, { id: props.match.params.commentId })
      );
      const { id, isProfane, userId } = result.data.getComment;

      // keep state
      setCommentData(result);
      setUserId(userId);
      setCommentCurrentProfaneState(isProfane);
      setCommentId(id);
    } catch (error) {
      toast.error(`Error while fetching Comment data ${JSON.stringify(error)}`);
    }
  };

  // get the profane flagging demerit point from the current data at db
  const getPointSystemForFlagesContent = async () => {
    let pointSystemResult = await getPointSystemByTypeAsync(
      "FLAGGED_REMOVED_CONTENT"
    );

    if (pointSystemResult.result) {
      setDemeritPoint(pointSystemResult.point);
    } else {
      toast.error(`${pointSystemResult.message}`);
    }
  };

  // make sure we load the page after the state for counts are updated
  useEffect(() => {
    if (commentId && demeritPoint) {
      setIsLoading(false);
    }
  }, [commentId, demeritPoint]);

  const handleReturn = () => {
    if (props.match.params.userPostId) {
      props.history.push(
        `/userPosts/details/${props.match.params.userPostId}/tab/Comments`
      );
    } else if (props.match.params.commentReportId) {
      props.history.push(
        `/commentReports/details/${props.match.params.commentReportId}`
      );
    } else {
      props.history.push(`/comments`);
    }
  };

  const handleFormSubmission = async (event) => {
    event.preventDefault();
    await markAsProfaneFunction();
  };

  const markAsProfaneFunction = async () => {
    setFormSubmitInProgress(true);

    let opperationResultMessage = "";

    if (!commentCurrentProfaneState) {
      // update comment data at dynamo db
      let updateProfaneStatusToTrueResult = await updateUserCommentProfaneStatus(
        commentId,
        true
      );
      if (!updateProfaneStatusToTrueResult.result) {
        toast.error(updateProfaneStatusToTrueResult.message);
        setFormSubmitInProgress(false);
        return;
      }

      opperationResultMessage = updateProfaneStatusToTrueResult.message;
    } else {
      // update comment data at dynamo db
      let updateProfaneStatusToFalseResult = await updateUserCommentProfaneStatus(
        commentId,
        false
      );
      if (!updateProfaneStatusToFalseResult.result) {
        toast.success(updateProfaneStatusToFalseResult.message);
        setFormSubmitInProgress(false);
        return;
      }

      opperationResultMessage = updateProfaneStatusToFalseResult.message;
    }

    // go back to list
    setTimeout(function () {
      toast.success(opperationResultMessage);
      handleReturn();
    }, GlobalSubmitUIDelay.DefaultDelay);
  };

  const updateUserCommentProfaneStatus = async (commentId, newStatus) => {
    let formSubmissionResult = {
      result: true,
      message: "",
    };
    try {
      let input = {
        id: commentId,
        isProfane: newStatus,
      };
      let userCommentUpdateResult = await API.graphql(
        graphqlOperation(updateComment, { input })
      );

      // check result
      if (userCommentUpdateResult) {
        formSubmissionResult.message = `Comment ${
          newStatus ? "Marked As Profane" : "UnMarked from Profane"
        } successfully`;
      }
    } catch (userUpdateError) {
      formSubmissionResult.result = false;
      formSubmissionResult.message = `Error while updating Comment ${JSON.stringify(
        userUpdateError,
        null,
        2
      )}`;
    }

    return formSubmissionResult;
  };

  // functionality to apply demerit points to post owner
  const applyDemeritPoints = async (positiveNeggative) => {
    setFormSubmitDemeritInProgress(true);

    // fetch current start points of the post owner
    let userCurrentPointsResult = await getCurrentUserStarPoints(userId);

    if (userCurrentPointsResult.result) {
      let updateUserPointsResult = await updateUserStarPointsByUserId(
        userId,
        userCurrentPointsResult.currentPoints + positiveNeggative * demeritPoint
      );

      // check the result
      if (!updateUserPointsResult.result) {
        toast.error(`${updateUserPointsResult.message}`);
        setFormSubmitInProgress(false);
        return;
      } else {
        // mark the post as profane
        // which will have the return handler inside
        await markAsProfaneFunction();
      }
    } else {
      toast.error(`${userCurrentPointsResult.message}`);
      setFormSubmitInProgress(false);
      return;
    }
  };

  return (
    <>
      <PagePreLoad isLoading={isLoading}>
        <Form onSubmit={handleFormSubmission} noValidate>
          <CardContainer
            header={`${
              commentCurrentProfaneState
                ? "UnMark Comment from Profanity flag "
                : "Mark Comment as Profane"
            } `}
            submitButton={
              <ButtonInput
                label={commentCurrentProfaneState ? "UnMark" : "Mark"}
                variant={
                  commentCurrentProfaneState
                    ? BootstrapVariants.Success
                    : BootstrapVariants.Danger
                }
                formSubmitInProgress={formSubmitInProgress}
                formSubmittingText={"In Progress..."}
                disabled={formSubmitDemeritInProgress}
              />
            }
            extraButtons={
              !commentCurrentProfaneState && (
                <ButtonInput
                  label={"Mark and Apply Demerit Points "}
                  type="button"
                  variant={BootstrapVariants.Danger}
                  formSubmitInProgress={formSubmitDemeritInProgress}
                  formSubmittingText={"In Progress..."}
                  onClick={() => applyDemeritPoints(+1)}
                  disabled={formSubmitInProgress}
                />
              )
            }
            backButton={
              <ButtonInput
                label="Back to List"
                type="button"
                variant={BootstrapVariants.OutlineSecondary}
                onClick={() => handleReturn()}
              />
            }
          >
            {generalError && (
              <Alert variant={BootstrapVariants.Danger}>{generalError}</Alert>
            )}
            <span>
              By clicking on{" "}
              <b>{commentCurrentProfaneState ? "UnMark" : "Mark"}</b>, Comment
              will be{" "}
              {commentCurrentProfaneState
                ? "unmarked from profane account"
                : "marked as a profane account"}
              , do you want to proceed?
            </span>
          </CardContainer>
        </Form>
        <PostGeneralInfo
          providedModelData={commentData}
          userId={props.match.params.userId}
        />
      </PagePreLoad>
    </>
  );
};

export default CommentProfane;
